import React from "react";
import {Box, Typography} from "@mui/material";

export default function Hero({title, subtitle, backgroundImageUrl, children, ...props}) {
    return (
        <Box style={{backgroundColor: "#3f6588", padding: '5em 1em', color: 'white'}} {...props}>
            <Typography variant={"h1"} textAlign={"center"} className={'hero-title'}>{title}</Typography>
            <Typography variant={"subtitle1"} textAlign={"center"}>{subtitle}</Typography>
            {children}
        </Box>
    )
};
